<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
      fill="var(--wp-text-warning)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z"
      fill="var(--wp-text-warning)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.22282 4.22282C4.61335 3.8323 5.24651 3.8323 5.63704 4.22282L9.87704 8.46283C10.2676 8.85335 10.2676 9.48651 9.87704 9.87704C9.48651 10.2676 8.85335 10.2676 8.46283 9.87704L4.22282 5.63704C3.8323 5.24651 3.8323 4.61335 4.22282 4.22282Z"
      fill="var(--wp-text-warning)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.123 14.123C14.5135 13.7324 15.1467 13.7324 15.5372 14.123L19.7772 18.363C20.1677 18.7535 20.1677 19.3867 19.7772 19.7772C19.3867 20.1677 18.7535 20.1677 18.363 19.7772L14.123 15.5372C13.7324 15.1467 13.7324 14.5135 14.123 14.123Z"
      fill="var(--wp-text-warning)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.7772 4.22282C20.1677 4.61335 20.1677 5.24651 19.7772 5.63704L15.5372 9.87704C15.1467 10.2676 14.5135 10.2676 14.123 9.87704C13.7324 9.48651 13.7324 8.85335 14.123 8.46283L18.363 4.22282C18.7535 3.8323 19.3867 3.8323 19.7772 4.22282Z"
      fill="var(--wp-text-warning)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.0672 4.93279C19.4577 5.32331 19.4577 5.95648 19.0672 6.347L15.5372 9.877C15.1467 10.2675 14.5135 10.2675 14.123 9.877C13.7324 9.48647 13.7324 8.85331 14.123 8.46279L17.653 4.93279C18.0435 4.54226 18.6767 4.54226 19.0672 4.93279Z"
      fill="var(--wp-text-warning)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.87704 14.123C10.2676 14.5135 10.2676 15.1467 9.87704 15.5372L5.63704 19.7772C5.24651 20.1677 4.61335 20.1677 4.22282 19.7772C3.8323 19.3867 3.8323 18.7535 4.22282 18.363L8.46283 14.123C8.85335 13.7324 9.48651 13.7324 9.87704 14.123Z"
      fill="var(--wp-text-warning)"
    />
  </svg>
</template>
